<script>
	import { masterData } from "src/store/store";
	import {
		caseStatusOptions,
		caseOriginDisplay,
		caseOriginOptions,
	} from "src/utils/options";

	export let row = {};
	export let key = "";
	export let event;
	export let action;
	export let options = [];
	export let format = "";
	export let className = "";
	export let label = "";
	export let index = -1;

	let value = "";

	$: if (key === "carAssetOwners") {
		value =
			$masterData.carAssetOwners?.find(
				(item) => item.id === row["assetOwnerId"]
			)?.name || "";
	}

	$: if (key === "status") {
		value =
			caseStatusOptions.find((item) => item.value === row["status"])
				?.label || "";
	}

	$: if (key === "caseOrigin") {
		value =
			caseOriginOptions.find(
				(option) => option.value === row["caseOrigin"]
			)?.label || row["caseOrigin"];
	}
</script>

<span>
	{value}
</span>
